import { AUTH_API, handleApiError } from '../../utils/axios';

export const getUserNotes = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/notes?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPublicNotes = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/notes/public?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getNoteById = async (noteId) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/notes/${noteId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createNote = async (note) => {
  try {
    const { data } = await AUTH_API.post('/api/v1/notes', note);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateNote = async (noteId, note) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/notes/${noteId}`, note);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteNote = async (noteId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/notes/${noteId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
